import { createContext } from 'react';
export const EllipsisContext = createContext({});
//# sourceMappingURL=EllipsisContext.js.map